// Get Vue instance
import Vue from 'vue';

// Imports
import Svg from './global/Icon';
import MainContent from './global/MainContent';
import Tabs from './global/Tabs';
import Tab from './global/Tab';
import Sidebar from './global/Sidebar';
import ButtonBack from './global/ButtonBack.vue';
import Container from './global/Container.vue';
import SubHeader from './global/SubHeader';
import Action from './global/Action';
import FooterBar from './global/FooterBar';
import Dropdown from './global/Dropdown';
import Search from './global/Search';
import Error from './global/Error';
import Toolbox from './global/Toolbox';
import Gravatar from './global/Gravatar';
import GravatarGroup from './global/GravatarGroup';
import Selection from './global/Selection';
import Timeframe from './global/Timeframe';
import vSelect from 'vue-select';
import Pikaday from './global/Pikaday';
import Calendar from './global/Dates';
import Rangepicker from './global/Rangepicker';
import Percents from './global/Percents';
import ChannelList from './global/ChannelList';
import ChannelListSingle from './global/ChannelListSingle';
import ChannelListGroup from './global/ChannelListGroup';
import Chat from './global/Chat';
import Bubble from './global/Bubble';
import ChatBubble from './global/ChatBubble';
import Profile from './global/Profile';
import Numeric from './global/Numeric';
import Card from './global/dashboard/Card'

// Register components in Vue
Vue.component('icon', Svg);
Vue.component('main-content', MainContent);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('sidebar', Sidebar);
Vue.component('button-back', ButtonBack);
Vue.component('container', Container);
Vue.component('sub-header', SubHeader);
Vue.component('action', Action);
Vue.component('footer-bar', FooterBar);
Vue.component('dropdown', Dropdown);
Vue.component('search', Search);
Vue.component('error', Error);
Vue.component('toolbox', Toolbox);
Vue.component('gravatar', Gravatar);
Vue.component('gravatar-group', GravatarGroup);
Vue.component('selection', Selection);
Vue.component('timeframe', Timeframe);
Vue.component('v-select', vSelect);
Vue.component('pikaday', Pikaday);
Vue.component('calendar', Calendar);
Vue.component('rangepicker', Rangepicker);
Vue.component('percents', Percents);
Vue.component('channel-list', ChannelList);
Vue.component('profile-data', Profile);
Vue.component('channel-list-single', ChannelListSingle);
Vue.component('channel-list-group', ChannelListGroup);
Vue.component('chat', Chat);
Vue.component('Bubble', Bubble);
Vue.component('chatBubble', ChatBubble);
Vue.component('numeric', Numeric);
Vue.component('card', Card);



// WEBPACK FOOTER //
// ./src/js/components/globals.js